import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import InvoicePendingsList, { DispatchProps, OwnProps, StateProps } from './InvoicePendingsList';
import { StoreState } from 'src/store/reducers';
import { QueryParams } from 'src/types/grid';
import { getInvoiceDocs } from '../../../../../../store/actions/invoice-actions';

function mapStateToProps(state: StoreState, ownProps: OwnProps): StateProps {
    return {
        data: state.invoices.dataDocs,
        inProgress: state.invoices.inProgress,
    };
}

function mapDispatchToProps(dispatch: Dispatch, ownProps: OwnProps): DispatchProps {
    return {
        getData: (params: QueryParams) => dispatch(getInvoiceDocs(params)),
    };
}

const InvoiceDocsListScreen = connect<StateProps, DispatchProps, OwnProps, StoreState>(
    mapStateToProps,
    mapDispatchToProps,
)(InvoicePendingsList);

export default InvoiceDocsListScreen;
